import React from 'react';
import Tabs from './components/Tabs';

export default function App() {
  return (
    <main className="min-h-screen bg-black text-[#d4b084] flex flex-col items-center justify-center px-4 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-[#d4b084]"></div>
      <div className="absolute bottom-0 left-0 w-full h-1 bg-[#d4b084]"></div>
      
      <Tabs />
      
      <footer className="mt-20 text-sm text-[#d4b084]/70">
        © AFW – Marseille, France – 2025 • contact@antiquefranceworldwide.com
      </footer>
    </main>
  );
}